import type { StateCreator } from 'zustand';
import { StriqueUser } from '@/types/user.types';

export interface UserState {
  user: StriqueUser | null;
  setUser: (user: StriqueUser) => void;
}

export const createUserState: StateCreator<UserState> = (set) => ({
  user: null,
  setUser: (user: StriqueUser) => set((state) => ({ ...state, user }))
});
